import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllRentalLocation } from 'features/rental-location/actions';
import { useSearchParams } from 'react-router-dom';
import { useAppContext } from 'components/Context/AppContext';
import ButtonAdd from 'components/Global/ButtonAdd';
import Tabs, { TabPane } from 'components/Global/Tabs';
import ZoneTab from './Zone';
import { useNavigate } from 'react-router-dom';
import ZoneTypeTab from './ZoneType';

const ZoneComponent = () => {
  const { setShowSpinner } = useAppContext();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState('');
  const [showModal, setShowModal] = useState({ show: false, id: 0 });
  const isLoading = useSelector((state) => state.zone.isLoading);

  const tabActive = searchParams.get('tab-active');

  const handleAdd = () => {
    if (activeTab === 'Zona') {
      navigate(`/zone/create?tab=${tabActive}`);
    }

    if (activeTab === 'Tipe Daerah Zona') {
      setShowModal({ show: true, id: 0 });
    }
  };

  useEffect(() => {
    if (!tabActive) {
      setSearchParams({ 'tab-active': 'Zona' });
    } else {
      setActiveTab(tabActive);
    }
  }, [tabActive]);

  useEffect(() => {
    dispatch(getAllRentalLocation());
  }, []);

  useEffect(() => {
    if (isLoading) {
      setShowSpinner(true);
    } else {
      setShowSpinner(false);
    }
  }, [isLoading]);

  return (
    <div className="zone">
      <Tabs activeTab={activeTab} setActiveTab={setActiveTab}>
        <TabPane label="Zona">
          <ZoneTab />
        </TabPane>
        <TabPane label="Tipe Daerah Zona">
          <ZoneTypeTab showModal={showModal} setShowModal={setShowModal} />
        </TabPane>
      </Tabs>

      <div className="button-wrapper-new">
        <ButtonAdd onClick={handleAdd} label={tabActive === 'Zona' ? 'Tambah Zona' : 'Tambah Tipe Zona'} />
      </div>
    </div>
  );
};

export default ZoneComponent;
